<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-21 16:42:53
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-10-12 15:34:18
 * @FilePath: \sns-user-frontend\src\views\thread\web\components\allComment.vue
 * @Description: 
-->
<template>
  <CommentEditor 
    v-if="showEditor && props.modelValue.buff !== 1 && props.modelValue.buff !== 3"
    :authorInfo="authorInfo" 
    :tid="props.modelValue.id"
    :threadInfo="props.modelValue"
    @update="onUpdate"
    @create="onCreate"
  />
  <div class="comment-close" v-else>
    {{$t('closeComment')}}
  </div>
  <div class="comment-menu">
    <span>{{$t('allComments')}}({{commentCount}})</span>
    <el-dropdown popper-class="comment-menu">
      <div class="sort-type">
        <svg-icon name="icon-sort"/>
        <span>{{$t(currentSort.label)}}</span>
      </div>
      <template #dropdown>
        <dl 
          class="comment-menu-list"
        >
          <dt
            v-for="item in sortOptions"
            :key="`${item.label}${item.value}`"
            @click="onSelectSort(item)"
          >{{$t(item.label)}}</dt>
        </dl>
      </template>
    </el-dropdown>
  </div>
  <CommentCard 
    v-for="({id, replyPage}, index) in commentList"
    :key="id"
    v-model="commentList[index]"
    :authorInfo="authorInfo"
    :threadInfo="props.modelValue"
    :actionPop="actionPop"
    @reply="showCommentDetail"
    @edit="editContent"
    @updateCount="updateCount"
    @updateList="onUpdate"
  >
    <template v-if="(replyPage.total && replyPage.rows.length)">
      <CommentCard 
        v-for="(replyCard, rdex) in replyPage.rows"
        :key="replyCard.id"
        v-model="replyPage.rows[rdex]"
        :threadInfo="props.modelValue"
        :actionPop="actionPop"
        @reply="showCommentDetail"
        @edit="editContent"
        @updateCount="updateCount"
        @updateSecondList="onUpdate"
      />
      <p 
        v-if="(replyPage.total > 3)" 
        class="view-all"
        @click="showCommentDetail({
          parentCid: id,
        });clickViewMore({
          parentCid: id
        });"
      >
      {{ $t('viewAllReplies', replyPage.total) }}
      </p>
    </template>
  </CommentCard>
  <pageStatus v-if="listStatus" :status="listStatus"/>
  <el-pagination
    v-model:current-page="currentPage"
    v-model:page-size="pageSize"
    :small="false"
    layout="prev, pager, next, jumper"
    :total="totalNum"
    @current-change="queryCommentList"
    :hide-on-single-page="true"
    style="margin-bottom: 0px;"
  />
  <CommentDetail 
    v-model="visible" 
    :sortType="currentSort.value"
    :cid="cid"
    :rid="rid"
    :tid="props.modelValue.id"
    :commentData="commentData"
    :threadInfo="props.modelValue"
    :closeStatus="props.modelValue.buff === 1 || props.modelValue.buff === 3 "
    :actionPop="actionPop"
    @refresh="onCreate"
  />
</template>

<script setup>
import http from '@/service'

import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
const userStore = useUserStore()
const { getPermission } = storeToRefs(userStore)

const route = useRoute()
const { proxy } = getCurrentInstance()

const showEditor = ref(false)

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => {}
  },
  actionPop: {
    type: Boolean,
    default: true
  }
})

// 排序选项
const sortOptions = reactive([{
  label: 'mostLike',
  value: 3
}, {
  label: 'latest',
  value: 4
}, {
  label: 'earliest',
  value: 1
}])
// 拥有标记权限的，显示标记排序
if (getPermission.value.commentMark) {
  sortOptions.push({
    label: 'mostMark',
    value: 5
  })
}
let storageSort = localStorage.getItem('commentSort') ? JSON.parse(localStorage.getItem('commentSort')) : sortOptions[0]
let currentSort = ref(storageSort)

// 选择排序方式
const onSelectSort = (item) => {
  currentSort.value = { ...item }
  currentPage.value = 1
  localStorage.setItem('commentSort', JSON.stringify(item))
  queryCommentList()
}

// 评论总数
let commentCount = ref(0)
// 作者信息
let authorInfo = ref({})

const listStatus = ref('')

const commentData = ref(null)

// 当前页码
let currentPage = ref(1)
// 页码条目个数
let pageSize = 15
// 列表总数
let totalNum = ref(0)

// 评论列表
let commentList = ref([])

const queryCommentList = async () => {
  listStatus.value = ''
  await http.getCommentList({
    limit: pageSize,
    page: currentPage.value,
    sortType: currentSort.value.value,
    tid: props.modelValue.id,
    needFeaturedStick: currentSort.value.value === 3
  }).then(({ code, data, msg }) => {
    const { rows = [], total = 0 } = data || {}
    if (code !== 200) {
      listStatus.value = 'error'
    }
    if (code === 200 && !rows.length) {
      listStatus.value = 'noContent'
    }
    totalNum.value = total
    commentList.value = [ ...rows ]
  })
}

let visible = ref(false)
let cid = ref('')
let rid = ref('')

const clickViewMore = (detail) => {
  proxy.$ga('click_post_detail_entry', {
    "screen_name": route.name,
    "thread_category": props.modelValue.type,
    "thread_id": route.params.id,
    "circle_id": props.modelValue.circleBasicInfo?.id,
    "circle_name": props.modelValue.circleBasicInfo?.name,
    "post_id": detail?.parentCid || detail?.id,
    "position": 3
  })
}

const showCommentDetail = (detail) => {
  cid.value = detail.parentCid || detail.id
  rid.value = detail.parentCid ? detail.id : ''
  commentData.value = { ...detail }
  visible.value = true
}

const updateCount = () => {
  commentCount.value = commentCount.value - 1
}

const editContent = (data) => {
  data.isEdit = true
  showCommentDetail(data)
}

const updateViewCount = () => {
  http.getThreadInfo({
    id: props.modelValue.id
  }).then(({code, data, msg}) => {
    if (code === 200 && data) {
      commentCount.value = data.threadStat.commentCount
    }
  })
}

const onUpdate = (data) => {
  commentData.value = null
  queryCommentList()
  updateViewCount()
}

const onCreate = (data) => {
  commentData.value = null
  setTimeout(() => {
    queryCommentList()
    updateViewCount()
  }, 1000)
}




watch(() => props.modelValue, (val) => {
  if (!val || !Object.keys(val).length) return
  commentCount.value = val.threadStat.commentCount
  const { uid: id, avatar, iconLink: icon, nickname } = val.publishUserInfo
  authorInfo.value = { id, avatar, icon, nickname }
}, {
  immediate: true,
  deep: true
})

watch(currentPage, (val) => {
  nextTick(() => {
    document.getElementsByClassName('comment-editor')[0].scrollIntoView()
  })
})


onMounted(async () => {
  await queryCommentList()
  const { parentCid, replyCid } = route.query
  showEditor.value = true
  if (parentCid) {
    showCommentDetail({
      parentCid,
      id: replyCid || ''
    })
  }
})


onActivated(async () => {
  await queryCommentList()
  showEditor.value = true
})

onDeactivated(() => {
  showEditor.value = false
})

onUnmounted(() => {
  showEditor.value = false
})

</script>

<style lang="postcss" scoped>
.comment-menu {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 792px;
  margin-bottom: 8px;
  padding-top: 40px;
  border-top: 1px solid var(--line);
  span {
    font-size: 14px;
    font-family: "orbit-M";
    color: var(--text-secondary);
    line-height: 100%;
  }
  .sort-type {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    .svg-icon {
      margin-right: 8px;
      color: var(----color-text-description);
    }
    span {
      color: var(--text-primary);
      font-family: "orbit-R";
    }
  }
  &-list {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    justify-content: center;
    padding: 8px 0;
    overflow: hidden;
    dt {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 100%;
      font-size: 14px;
      padding: 11px 24px;
      cursor: pointer;
    }
    dt:hover {
      background-color: var(--background-light);
    }
  }
}
.page-status {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 084px;
}
.view-all {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 197px;
  height: 38px;
  padding-left: 44px;
  margin-top: 24px;
  font-size: 14px;
  font-family: "orbit-R";
  line-height: 100%;
  color: var(--theme);
  cursor: pointer;
}

.comment-close {
  font-size: 18px;
  color: var(--text-hint);
  text-align: center;
  line-height: 150%;
  padding: 16px;
  margin: 56px 0 48px 0;
  background: var(--background-plain);
  position: relative;
  &::before,&::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 100%;
    top: 0;
    background: var(--background-plain);
    border-radius: 8px 0 0 8px;
  }
  &::before {
    left: -16px;
  }
  &::after {
    right: -16px;
    border-radius: 0 8px 8px 0;
  }
}

</style>

<style lang="postcss">
.comment-menu {
  --el-popper-border-radius: 8px;
  .el-popper__arrow {
    display: none;
  }
}
</style>